import { render, staticRenderFns } from "./GenericProfileInfo.vue?vue&type=template&id=84b71f32&scoped=true&"
import script from "./GenericProfileInfo.vue?vue&type=script&lang=js&"
export * from "./GenericProfileInfo.vue?vue&type=script&lang=js&"
import style0 from "./GenericProfileInfo.vue?vue&type=style&index=0&id=84b71f32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b71f32",
  null
  
)

component.options.__file = "GenericProfileInfo.vue"
export default component.exports